import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mail, Lock, ArrowRight, Loader2 } from "lucide-react";
import { useClientAuth } from "../context/ClientAuthContext";
import { toast } from "sonner";

export default function ClientLogin() {
  const { login } = useClientAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const redirectTo = location.state?.from || "/account";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Connexion réussie");
      navigate(redirectTo, { replace: true });
    } else {
      toast.error(res.error);
    }
  };

  return (
    <section className="min-h-[70vh] bg-fegray-light flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md fe-card p-8 lg:p-10" data-testid="client-login-card">
        <p className="text-fegreen font-medium uppercase tracking-[0.25em] text-xs mb-3">
          — Espace client
        </p>
        <h1 className="text-3xl font-bold text-fegray-dark mb-2">Connexion</h1>
        <p className="text-sm text-fegray mb-8">
          Retrouvez vos réservations, votre crédit d'impôt et vos préférences.
        </p>

        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="block text-xs uppercase tracking-wider text-fegray mb-2">
              Email <span className="text-fegreen">*</span>
            </label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-fegray/50" />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="client-login-email"
                placeholder="votre@email.fr"
                className="w-full bg-white border border-gray-200 rounded-xl pl-10 pr-4 py-3 text-fegray-dark focus:border-fegreen focus:ring-2 focus:ring-fegreen/20 focus:outline-none transition"
              />
            </div>
          </div>

          <div>
            <label className="block text-xs uppercase tracking-wider text-fegray mb-2">
              Mot de passe <span className="text-fegreen">*</span>
            </label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-fegray/50" />
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="client-login-password"
                placeholder="••••••••"
                className="w-full bg-white border border-gray-200 rounded-xl pl-10 pr-4 py-3 text-fegray-dark focus:border-fegreen focus:ring-2 focus:ring-fegreen/20 focus:outline-none transition"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            data-testid="client-login-submit"
            className="btn-green w-full disabled:opacity-50"
          >
            {loading ? (
              <><Loader2 className="w-4 h-4 animate-spin" /> Connexion…</>
            ) : (
              <>Se connecter <ArrowRight className="w-4 h-4" /></>
            )}
          </button>
        </form>

        <p className="text-sm text-fegray text-center mt-6">
          Pas encore de compte ?{" "}
          <Link
            to="/account/register"
            state={{ from: redirectTo }}
            className="text-fegreen font-semibold hover:underline"
            data-testid="link-to-register"
          >
            Créez votre compte
          </Link>
        </p>
      </div>
    </section>
  );
}
